import React from 'react';
import Box from '@mui/material/Box';
import Link from 'next/link';
import type {SxProps, Theme} from '@mui/material/styles';
import {fontWeight} from '@/styles/tokens';
import type {TextPart} from '@/util/contents/drawpost-data';

interface RenderPartsOptions {
    /** sx applied to `bold` spans. Defaults to semibold. */
    boldSx?: SxProps<Theme>;
    /** inline style applied to `link` parts. Omit for the default next/link styling. */
    linkStyle?: React.CSSProperties;
}

const defaultBoldSx: SxProps<Theme> = {fontWeight: fontWeight.semibold};

/**
 * Renders a rich-text paragraph (text / bold / link parts) shared across the
 * drawpost case-study sections. Bold and link appearance is customisable per call.
 */
export function renderParts(parts: readonly TextPart[], {boldSx = defaultBoldSx, linkStyle}: RenderPartsOptions = {}) {
    return parts.map((part, i) => {
        if (part.type === 'link')
            return (
                <Link key={i} href={part.href} style={linkStyle}>
                    {part.text}
                </Link>
            );
        if (part.type === 'bold')
            return (
                <Box key={i} component="span" sx={boldSx}>
                    {part.text}
                </Box>
            );
        return <React.Fragment key={i}>{part.text}</React.Fragment>;
    });
}
